import React from 'react';
import specialsData from '../data/specials.json';
import './Specials.css';

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

function Specials() {
  const today = DAYS[(new Date().getDay() + 6) % 7];

  const specialsByDay = DAYS.map(day => ({
    day,
    specials: specialsData.flatMap(restaurant =>
      restaurant.specials
        .filter(special => special.day === day)
        .map(special => ({
          ...special,
          restaurant: restaurant.name,
          address: restaurant.address,
          url: restaurant.url,
        }))
    ),
  })).filter(group => group.specials.length > 0);

  return (
    <div className="specials">
      <h1 className="specials-title">Restaurant Specials</h1>
      <p className="specials-subtitle">
        Weekly restaurant specials by day of the week
      </p>

      {specialsByDay.length === 0 ? (
        <p className="specials-empty">No specials listed yet.</p>
      ) : (
        <div className="specials-groups">
          {specialsByDay.map(group => (
            <section
              className={`specials-group${group.day === today ? ' specials-group--today' : ''}`}
              key={group.day}
            >
              <div className="specials-group-header">
                <h2 className="specials-group-title">{group.day}</h2>
                {group.day === today && <span className="specials-today-badge">Today</span>}
              </div>
              <div className="specials-grid">
                {group.specials.map(special => (
                  <div className="specials-card" key={`${special.restaurant}-${special.title}`}>
                    <h3 className="specials-card-restaurant">
                      {special.url ? (
                        <a href={special.url} target="_blank" rel="noopener noreferrer">
                          {special.restaurant} ↗
                        </a>
                      ) : (
                        special.restaurant
                      )}
                    </h3>
                    {special.address && (
                      <p className="specials-card-address">{special.address}</p>
                    )}
                    <p className="specials-card-title">{special.title}</p>
                    {special.price && <p className="specials-card-price">{special.price}</p>}
                    {special.notes && <p className="specials-card-notes">{special.notes}</p>}
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}

export default Specials;
